import React from 'react';

import * as utils from '../utils/utils';
import Footer from './common/Footer';
import { Row } from 'react-bootstrap';

const Error = () => {
  return (
    <div className="container-fluid">
      <div className="branding">
        <img className="mainLogo" src={utils.getMainLogo()} />
      </div>
      <Row>
        <p>
          Cognomos is a web-based tool that allows you to rank your class preferences. It guarantees that you will get a
          fair allocation of classes.
        </p>

        <p>If your school is using Cognomos, you should have received an email directing you to a specific URL.</p>
      </Row>

      <Footer />
    </div>
  );
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.js